import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { throwError, Observable, catchError } from 'rxjs';
import { environment } from '../environments/environment';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class MembershipService {
  constructor(public http: HttpClient, private router: Router) {}
  headers = new HttpHeaders().set('Content-Type', 'application/json');

  base_url = environment.apiUrl;

  sendInvite(data: any): Observable<any> {
    return this.http
      .post(this.base_url + `membership/invite`, data, {
        headers: this.headers,
      })
      .pipe(
        catchError((error: any) => {
          return throwError(error);
        })
      );
  }

  // acceptInvite(data: any): Observable<any> {
  //   return this.http
  //     .post(this.base_url + `membership/accept`, data, {
  //       headers: this.headers,
  //     })
  //     .pipe(
  //       catchError((error: any) => {
  //         return throwError(error);
  //       })
  //     );
  // }
  // resendInvite(id: any): Observable<any> {
  //   return this.http
  //     .post(this.base_url + `user/invite/${id}/resend`, {
  //       headers: this.headers,
  //     })
  //     .pipe(
  //       catchError((error: any) => {
  //         return throwError(error);
  //       })
  //     );
  // }
  getInvites(): Observable<any> {
    return this.http.get(this.base_url + `user`).pipe(
      catchError((error: any) => {
        return throwError(error);
      })
    );
  }

  // deleteApiKey(data: any): Observable<any> {
  //   return this.http
  //     .delete(this.base_url + `organization/api-key`, { body: data })
  //     .pipe(
  //       catchError((error: any) => {
  //         return throwError(error);
  //       })
  //     );
  // }
}
